export default __webpack_public_path__ + "static/media/waster_greatsword.a411f34b.png";